import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Zap } from 'lucide-react'
import { toast } from 'sonner'

import { supabase } from '@/lib/supabase'
import AuthService from '@/services/auth.service'
import { useAuthStore } from '@/stores/authStore'
import { useBrandingStore } from '@/stores/brandingStore'
import { getDefaultRouteForRole, resolveAccessRole } from '@/utils/permissions'

export default function OAuthCallbackPage() {
  const navigate = useNavigate()
  const setTokens = useAuthStore((state) => state.setTokens)
  const platformName = useBrandingStore((state) => state.platform_name)

  useEffect(() => {
    let active = true

    async function completeGoogleLogin() {
      try {
        let session = (await supabase.auth.getSession()).data.session

        if (!session) {
          const code = new URLSearchParams(window.location.search).get('code')
          if (code) {
            const { data, error } = await supabase.auth.exchangeCodeForSession(code)
            if (error) {
              throw error
            }
            session = data.session
          }
        }

        const accessToken = session?.access_token
        if (!accessToken) {
          throw new Error('Nao foi possivel concluir a autenticacao com Google.')
        }

        const tokens = await AuthService.exchangeSupabaseGoogleToken(accessToken)
        if (!active) {
          return
        }

        setTokens(tokens)
        const route = getDefaultRouteForRole(resolveAccessRole(tokens.user))
        navigate(route, { replace: true })
      } catch (error) {
        const message =
          error instanceof Error && error.message.trim()
            ? error.message
            : 'Falha ao concluir o login com Google.'
        toast.error(message)
        navigate('/login', { replace: true })
      }
    }

    void completeGoogleLogin()

    return () => {
      active = false
    }
  }, [navigate, setTokens])

  return (
    <div className="auth-bg min-h-screen flex items-center justify-center p-4">
      <div className="glass-strong w-full max-w-md p-8 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[var(--color-brand)] to-[var(--color-secondary)] shadow-[var(--shadow-glow)]">
          <Zap size={28} className="text-white" />
        </div>
        <h1 className="text-2xl font-bold text-[var(--text-primary)]">
          Concluindo acesso ao <span className="gradient-text">{platformName || 'ISing'}</span>
        </h1>
        <p className="mt-2 text-sm text-[var(--text-muted)]">
          Aguarde enquanto validamos sua conta Google e carregamos sua sessao.
        </p>
      </div>
    </div>
  )
}
